import { Component, OnInit } from '@angular/core';

import { IonInput } from '@ionic/angular';

import { V2TopBarOptions } from '../../shared/components/v2/v2-top-bar/v2-top-bar.component';

@Component({
  selector: 'app-mesa',
  templateUrl: './mesa.page.html',
  styleUrls: ['./mesa.page.scss'],
})
export class MesaPage implements OnInit {

  constructor() { }

  ionViewWillEnter() {
    const pwdInput: IonInput = document.getElementById('rest-pwd-table-change-input') as any
    pwdInput.value = ''
  }

  ngOnInit() {
  }

  

}
